module.exports = __webpack_public_path__ + "static/media/download-icon.67413230.svg";